
import Button from 'components/Button'
import React from 'react'
import { Modal } from 'react-bootstrap'
import '../confirmDialog.css'

function ConfirmDialog({ title, show, handleSubmit, submitFunctionArgs, handleCancel, confirmButtonName ,cancelButtonName }) {
  return (
    <>
      <Modal show={show}
        // title={title}
        // onOk={() => handleSubmit()}

        onHide={handleCancel}

        size="lg"
        centered

      >

        <Modal.Header className="confirmation--header"
          closeButton>
          {/* <Modal.Title id="contained-modal-title-vcenter" > */}
          {title}
          {/* </Modal.Title> */}
        </Modal.Header>
        <div className="confirmation--footer">
          <div className="confirmation--footer-left">
            <Button id="cancelButton" onClickHandler={handleCancel}>{cancelButtonName}</Button>
          </div>


          <div className="confirmation--footer-right">
          <Button id="acceptButton" onClickHandler={() => handleSubmit(submitFunctionArgs)}>{confirmButtonName}</Button>


          </div>
        </div>

      </Modal>
    </>
  )
}

export default ConfirmDialog            